import { NavLink } from 'react-router-dom';

export default function AdminSidebar() {
  return (
    <div className="bg-gray-800 text-white w-64 min-h-screen p-4 font-fairplay">
      <h2 className="text-2xl font-bold mb-6 font-fairplay">Admin Panel</h2>
      <nav className="space-y-2">
        <NavLink
          to="/admin"
          className={({ isActive }) =>
            isActive ? 'block p-2 bg-cyan-500 rounded' : 'block p-2 hover:bg-cyan-500 rounded'
          }
        >
          Dashboard
        </NavLink>
        <NavLink
          to="/admin/create-listing"
          className={({ isActive }) =>
            isActive ? 'block p-2 bg-cyan-500 rounded' : 'block p-2 hover:bg-cyan-500 rounded'
          }
        >
          Create Listing
        </NavLink>
        <NavLink
          to="/admin/add-car"
          className={({ isActive }) =>
            isActive ? 'block p-2 bg-cyan-500 rounded' : 'block p-2 hover:bg-cyan-500 rounded'
          }
        >
          Add Car
        </NavLink>
        <NavLink
          to="/admin/inspections"
          className={({ isActive }) =>
            isActive ? 'block p-2 bg-cyan-500 rounded' : 'block p-2 hover:bg-cyan-500 rounded'
          }
        >
          Inspections
        </NavLink>
        <NavLink
          to="/admin/admin-management"
          className={({ isActive }) =>
            isActive ? 'block p-2 bg-cyan-500 rounded' : 'block p-2 hover:bg-cyan-500 rounded'
          }
        >
          Admin Management
        </NavLink>
        <NavLink
          to="/admin/report"
          className={({ isActive }) =>
            isActive ? 'block p-2 bg-cyan-500 rounded' : 'block p-2 hover:bg-cyan-500 rounded'
          }
        >
          Reports
        </NavLink>
      </nav>
    </div>
  );
}
